import React from 'react';

/**
 * 尚未啟動的功能——入口留著、進得去、但整片打灰並掛上提示，讓人一眼知道
 * 這頁還不是正式運作中的功能。
 *
 * 這裡是唯一的名單來源：功能正式上線時，把它從名單移除即可,入口卡片、tab
 * 與頁面橫幅會一起恢復正常，不必逐頁改樣式。
 */

// 未啟動的管理頁（網址精確比對，子路徑一併算入）
export const NOT_LIVE_PATHS = [
  '/qm/monthly-records',
  '/qm/adaptive-cookie',
  '/qm/chargeable-import',
  '/qm/timesheet-check',
];

// 未啟動的 QM 儀表板頁內 tab（ScrollableTabs 的 tab.id）
export const NOT_LIVE_QM_TABS = ['timesheets', 'chargeableHours'];

export const isNotLivePath = (pathname) =>
  NOT_LIVE_PATHS.some((p) => pathname === p || pathname.startsWith(`${p}/`));

/** 入口上的小標籤（Management 卡片、tab 名稱後面） */
export const NotLiveBadge = ({ className = '' }) => (
  <span
    className={`inline-flex items-center rounded bg-slate-200 px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-slate-500 ${className}`}
  >
    Not live
  </span>
);

/** 頁面／tab 內容上方的說明橫幅 */
export const NotLiveBanner = ({ className = '' }) => (
  <div
    className={`rounded-lg border border-slate-300 bg-slate-100 px-4 py-3 text-sm text-slate-600 ${className}`}
  >
    <p>
      <span className="font-semibold text-slate-700">This feature is not live yet.</span>{' '}
      It is open for preview only — the data and actions here are not part of daily operations.
    </p>
  </div>
);

export default NotLiveBanner;
